import i18n from './i18n';

const LanguageKey = () => {
  switch (i18n.language) {
    case 'en-AU': 
      return 'au'
    case 'en-GB':
      return 'gb'
    default:
      return 'en'
  }
}

export default LanguageKey